import { Modal } from "react-bootstrap";
import { ModalBase } from "../../utils/modal_launcher";
import {
  formResponse,
  onSuccess,
  refetch,
  useApiGet,
  useApiMutation,
} from "../../utils/api";
import { SimpleForm } from "../../utils/simple_form";
import { toast } from "react-toastify";
import { useState } from "react";
import { daysFromNow, randomWord } from "../../utils/dev_tool";
import { capitalize } from "lodash";

const fields: Record<string, any> = {
  name: { required: true },
  from: { required: true, type: "date" },
  to: { required: true, type: "date" },
};

export const TripModal = ({ id, close }) => {
  const { post, saving } = useApiMutation();
  const [errors, setErrors] = useState({});
  const { data, unavailable } = id
    ? useApiGet({ trip_modal: `/api/user/trip_modal/${id}` })
    : { data: null, unavailable: null };

  if (id && unavailable) {
    return unavailable;
  }

  const trip = id ? data?.trip : {};

  const save = (trip) => {
    const endpoint = id ? `/api/user/update_trip/${id}` : "/api/user/create_trip";
    setErrors({});

    post(endpoint, { trip }).then(
      formResponse(() => {
        refetch("trip");
        refetch("trip_modal");
        toast.success("Trip saved");
        if (!id) {
          close();
        }
      }, setErrors)
    );
  };

  return (
    <ModalBase title={id ? "Edit Trip" : "New Trip"} close={close}>
      <Modal.Body>
        <SimpleForm
          fields={fields}
          data={trip}
          onSubmit={save}
          saving={saving}
          errors={errors}
          devToolValues={{
            name: `${capitalize(randomWord())} Trip`,
            from: daysFromNow(10),
            to: daysFromNow(15),
          }}
        />

        {id && (
          <>
            <hr />
            <ShareTrip trip={trip} />
          </>
        )}
      </Modal.Body>
    </ModalBase>
  );
};

const ShareTrip = ({ trip }) => {
  const { post, saving } = useApiMutation();

  const handleShare = (friend) => {
    post(`/api/user/share_trip/${trip.id}`, { friend_id: friend.id }).then(
      onSuccess(() => {
        toast.success(`Trip shared with ${friend.name}`);
        refetch("trip_modal");
      })
    );
  };

  const handleUnshare = (friend) => {
    if (confirm("Unshare with this friend?")) {
      post(`/api/user/unshare_trip/${trip.id}`, { friend_id: friend.id }).then(
        onSuccess(() => {
          toast.success(`Trip unshared with ${friend.name}`);
          refetch("trip_modal");
        })
      );
    }
  };

  return (
    <>
      <div className="fs-18 underline">Share</div>

      <div className="mt-2 mb-1 fs-13">
        {trip.share_status.length === 0 && (
          <div className="gray-8">No friends added yet</div>
        )}
        {trip.share_status.map((friend) => (
          <div
            key={friend.uuid}
            className="d-flex align-items-center justify-content-between fs-13"
          >
            {friend.name}
            <div>
              {friend.shared ? (
                <div className="d-flex align-items-center">
                  Shared
                  <button
                    className="btn btn-link fs-13 red ml-2"
                    onClick={() => handleUnshare(friend)}
                    disabled={saving}
                  >
                    <i className="bi bi-x fs-16"></i>
                  </button>
                </div>
              ) : (
                <button
                  className="btn btn-link fs-13"
                  onClick={() => handleShare(friend)}
                  disabled={saving}
                >
                  Share
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};
